var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "container" }, [
    !_vm.selectedNewsletter
      ? _c("div", { staticClass: "section-banner" }, [
          _c("a", { attrs: { href: "#newsletters" } }, [_vm._v("Newsletters")]),
          _vm._v(" "),
          _c("span", { staticClass: "nav-separator" }, [_vm._v(".")]),
          _vm._v(" "),
          _c("a", { attrs: { href: "#spring-activities" } }, [
            _vm._v("Spring Activities"),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "nav-separator" }, [_vm._v(".")]),
          _vm._v(" "),
          _c("a", { attrs: { href: "#summer-activities" } }, [
            _vm._v("Summer Activities"),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.selectedNewsletter
      ? _c("div", [
          _c("h1", { staticClass: "mt-5", attrs: { id: "newsletters" } }, [
            _vm._v("Newsletters"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "newsletters-grid" },
            _vm._l(_vm.generalNewsletters, function (n, i) {
              return _c("newsletter-item", {
                key: "g" + i,
                attrs: { newsletter: n },
                on: {
                  "item-selected": function ($event) {
                    _vm.selectedNewsletter = n
                  },
                },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "h2",
            { staticClass: "mt-5", attrs: { id: "spring-activities" } },
            [_vm._v("Spring Activities")]
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "h2",
            { staticClass: "mt-5", attrs: { id: "summer-activities" } },
            [_vm._v("Summer Activities")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "newsletters-grid" },
            _vm._l(_vm.summerActivities, function (n, i) {
              return _c("newsletter-item", {
                key: "s" + i,
                attrs: { newsletter: n },
                on: {
                  "item-selected": function ($event) {
                    _vm.selectedNewsletter = n
                  },
                },
              })
            }),
            1
          ),
        ])
      : _c(
          "div",
          [
            _c("newsletter-viewer", {
              attrs: { newsletter: _vm.selectedNewsletter },
              on: {
                cancel: function ($event) {
                  _vm.selectedNewsletter = null
                },
              },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "newsletters-grid" }, [
      _c("div", { staticClass: "coming-soon-card" }, [
        _c("p", [_vm._v("Spring Activities 2026")]),
        _vm._v(" "),
        _c("p", [_vm._v("Coming Soon")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }